import React from 'react'
import type {
  primitives,
  AuctionBlueprintScheduledOnlineReactiveArgs,
} from '@adc/blueprint'
import type { Maybe, Property } from '@adc/sdk/types'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import { hooks, useApplicationContext } from '@adc/ui-adc'
import PropertyProvider, {
  PropertyPageActionsType,
} from 'common/context/property'
import PropertyHeader from '../modules/propertyHeader'
import MessagesBanner from '../modules/messagesBanner'
import PropertyDetails from '../modules/propertyDetails'
import Breadcrumbs from '../modules/breadcrumbs'
import InvestmentInfo from '../modules/investmentInfo'
import SimilarPropertiesCarousel from '../modules/similarProperties'
import AuctionDetails from '../modules/auctionDetails'
import { StickyHeader } from '../modules/stickyHeader'
import { ConnectedCompSales } from '../modules/compsales'
import SeoLinksFooter from '../modules/seoLinksFooter'
import Disclaimer from '../modules/disclaimer'
import { CombinedListingType, ListingProvider } from '../context/listing'
import ActivePropertyWrapperContainer from './activePropertyWrapper'

type AuctionUser = primitives.AuctionUser
interface SparkOfferPropertyContentType {
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
  listing: CombinedListingType
  pageBannerRef: any
  user: AuctionUser
  isOnline: Maybe<boolean> | undefined
  property: Property
  propertyActions: PropertyPageActionsType
}

const SparkOfferPropertyContent = ({
  segment,
  listing,
  pageBannerRef,
  user,
  property,
  propertyActions,
}: SparkOfferPropertyContentType) => {
  return (
    <PropertyProvider property={property} propertyActions={propertyActions}>
      <ListingProvider listing={listing} segment={segment}>
        <StickyHeader />
        <Breadcrumbs />
        <MessagesBanner pageBannerRef={pageBannerRef} />
        <PropertyHeader />
        <InvestmentInfo />
        <AuctionDetails />
        <PropertyDetails key={String(user.logged_in)} hideBadges />
        <ConnectedCompSales />
        {/* @ts-ignore js file */}
        <SimilarPropertiesCarousel />
        <Disclaimer />
        <SeoLinksFooter />
      </ListingProvider>
    </PropertyProvider>
  )
}

interface SparkOfferPropertyContainerProps {
  pageBannerRef: any
}

const SparkOfferPropertyContainer = (
  props: SparkOfferPropertyContainerProps
) => {
  return (
    <ActivePropertyWrapperContainer
      {...props}
      childComponent={SparkOfferPropertyContent}
    />
  )
}

export default SparkOfferPropertyContainer
